"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _L2Panel = _interopRequireDefault(require("./L2Panel"));
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
var _navUtils = require("./nav-utils");

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
var L1NavItem = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2.default)(L1NavItem, _React$PureComponent);
  function L1NavItem() {
    var _this;
    _this = _React$PureComponent.call(this) || this;
    _this.windowResizeEventHandler = function () {
      _this.isMobile = _screenSizes.default.isMobile();
      _this.isTablet = _screenSizes.default.isTablet();
    };
    _this.onHover = function (hasL2) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handleNavigationDrawer = _this.props.handleNavigationDrawer;
        if (!_this.isMobile) {
          clearTimeout(_this.timeOutHandler);
          _this.timeOutHandler = setTimeout(function () {
            if (!hasL2) {
              _this.setHoveredState(true);
            } else {
              _this.setHoveredState(true, handleNavigationDrawer);
            }
          }, 0);
        }
        if (!_this.isMobile) {
          (0, _navUtils.handleScrollOnHover)(hasL2);
        }
      };
    };
    _this.setHoveredState = function (isHovered, handleNavigationDrawer) {
      if (handleNavigationDrawer === void 0) {
        handleNavigationDrawer = function handleNavigationDrawer() {
          /* default handleNavigationDrawer handler */
        };
      }
      _this.setState({
        hovered: isHovered
      }, function () {
        handleNavigationDrawer(isHovered);
      });
    };
    _this.onMouseLeave = function (e) {
      if (_this.isTablet) {
        _this.setState({
          isTabletLinkActive: false
        });
        var navigationLink = e == null ? void 0 : e.currentTarget;
        if (navigationLink != null && navigationLink.classList.contains('hide-nav-drawer')) {
          navigationLink == null ? void 0 : navigationLink.classList.remove('hide-nav-drawer');
        }
      }
      var handleNavigationDrawer = _this.props.handleNavigationDrawer;
      clearTimeout(_this.timeOutHandler);
      _this.timeOutHandler = setTimeout(function () {
        _this.setHoveredState(false, handleNavigationDrawer);
      }, 0);
    };
    _this.openNavigationDrawer = function (hasL2) {
      return function (e) {
        var handleNavigationDrawer = _this.props.handleNavigationDrawer;
        var hovered = _this.state.hovered;
        if (_this.isMobile) {
          if (hasL2) {
            e.preventDefault();
            e.stopPropagation();
            var hoveredM = _this.isMobile ? !hovered : true;
            clearTimeout(_this.timeOutHandler);
            _this.timeOutHandler = setTimeout(function () {
              _this.setHoveredState(hoveredM, handleNavigationDrawer);
            }, 0);
          }
        } else {
          clearTimeout(_this.timeOutHandler);
          _this.setHoveredState(false);
        }
      };
    };
    _this.closeNavigationDrawer = function (e) {
      var _e$currentTarget, _e$currentTarget$pare;
      e.stopPropagation();
      var navigationLink = e == null ? void 0 : (_e$currentTarget = e.currentTarget) == null ? void 0 : (_e$currentTarget$pare = _e$currentTarget.parentElement) == null ? void 0 : _e$currentTarget$pare.parentElement;
      if (navigationLink) {
        navigationLink == null ? void 0 : navigationLink.classList.add('hide-nav-drawer');
      }
      _this.setState({
        hovered: false,
        isTabletLinkActive: false
      });
      var handleNavigationDrawer = _this.props.handleNavigationDrawer;
      handleNavigationDrawer(false);
    };
    _this.resetHoverState = function (navElement) {
      _this.setState({
        isTabletLinkActive: true
      });
      /* Reset hover state when same link is re-opened */

      if (navElement != null && navElement.classList.contains('hide-nav-drawer')) {
        navElement == null ? void 0 : navElement.classList.remove('hide-nav-drawer');
        var handleNavigationDrawer = _this.props.handleNavigationDrawer;
        handleNavigationDrawer(true);
      }
    };
    _this.navigationItemHandler = function (e) {
      if (_this.isTablet) {
        var navigationLink = e == null ? void 0 : e.currentTarget;
        _this.resetHoverState(navigationLink);
      }
    };
    _this.navigationLinkHandler = function (hasL2, url) {
      return function (e) {
        if (_this.isTablet && hasL2) {
          var isTabletLinkActive = _this.state.isTabletLinkActive;
          if (isTabletLinkActive) {
            window.location.href = url;
          } else {
            var _e$currentTarget2, _e$currentTarget2$par;
            e.preventDefault();
            e.stopPropagation();
            var navigationLink = e == null ? void 0 : (_e$currentTarget2 = e.currentTarget) == null ? void 0 : (_e$currentTarget2$par = _e$currentTarget2.parentElement) == null ? void 0 : _e$currentTarget2$par.parentElement;
            _this.resetHoverState(navigationLink);
          }
        }
      };
    };
    _this.state = {
      hovered: false,
      isTabletLinkActive: false
    };
    _this.timeOutHandler = null;
    _this.isMobile = _screenSizes.default.isMobile();
    _this.isTablet = _screenSizes.default.isTablet();
    _this.windowResizeEventHandler = _this.windowResizeEventHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  var _proto = L1NavItem.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.windowResizeEventHandler);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.windowResizeEventHandler);
  }
  /**
   * Set state based on view port.
   */;

  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      dataLocator = _this$props.dataLocator,
      navL1Item = _this$props.navL1Item,
      hasL2 = _this$props.hasL2,
      config = _this$props.config,
      showDropdown = _this$props.showDropdown;
    var title = navL1Item.title,
      level = navL1Item.level,
      path = navL1Item.path,
      asPath = navL1Item.asPath,
      url = navL1Item.url,
      children = navL1Item.children;
    var hovered = this.state.hovered;
    var closeIcon = config.closeIcon;
    var isMobileActive = hovered && this.isMobile ? 'is-active' : '';
    return _react.default.createElement("li", {
      className: className + " cmp-navigation__item--level-" + level + " " + isMobileActive,
      onMouseEnter: this.onHover(hasL2),
      onMouseLeave: this.onMouseLeave,
      id: dataLocator,
      role: "menuitem",
      onClick: this.navigationItemHandler
    }, _react.default.createElement("div", {
      className: "cmp-navigation__container",
      onClick: this.openNavigationDrawer(hasL2)
    }, _react.default.createElement("div", {
      className: "arrow left"
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: config.leftIcon
    })), _react.default.createElement(_Anchor.default, {
      className: "cmp-navigation__item-link",
      to: url,
      as: asPath,
      title: title,
      "aria-label": title,
      onClick: this.navigationLinkHandler(hasL2, url)
    }, title), _react.default.createElement("div", {
      className: "arrow right"
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: config.rightIcon
    })), showDropdown && hasL2 && _react.default.createElement("div", {
      className: "down-arrow"
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: config.downIcon
    }))), hasL2 && _react.default.createElement(_L2Panel.default, {
      className: "cmp-navigation__group-wrapper",
      data: children,
      path: path,
      name: title,
      closeIcon: closeIcon,
      closeNavigationDrawer: this.closeNavigationDrawer
    }));
  };
  return L1NavItem;
}(_react.default.PureComponent);
L1NavItem.defaultProps = {
  dataLocator: '',
  config: {},
  showDropdown: false
};
var _default = L1NavItem;
exports.default = _default;
module.exports = exports["default"];